// Small image helpers shared by the capture/quality pipeline.

/** Load a data URL / object URL into a decoded HTMLImageElement. */
export function loadImage(src: string): Promise<HTMLImageElement> {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => resolve(img);
        img.onerror = (e) => reject(e);
        img.src = src;
    });
}
